

let VUE_APP_BASE_API_URL = process.env.VUE_APP_BASE_API_URL;
// console.log('VUE_APP_BASE_API_URL: ', VUE_APP_BASE_API_URL);

if (VUE_APP_BASE_API_URL && VUE_APP_BASE_API_URL.indexOf(":") === 0) {
  const baseDomain = window.location.protocol + "//" +  window.location.hostname;

  VUE_APP_BASE_API_URL = baseDomain + VUE_APP_BASE_API_URL;
}
console.log("VUE_APP_BASE_API_URL: ", VUE_APP_BASE_API_URL);

export const authUrl = process.env.production
    ? VUE_APP_BASE_API_URL || "http://localhost/"
    : VUE_APP_BASE_API_URL || "http://localhost:4000/";

export const apiUrl = process.env.production
    ? VUE_APP_BASE_API_URL + "api" || "http://localhost/api"
    : VUE_APP_BASE_API_URL + "api" || "http://localhost:4000/api";

export const serializeObjToGetStr = obj => {
        const queryArray: string[] = [];
        for (const p in obj) {
          if (obj.hasOwnProperty(p)) {
            queryArray.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          }
        }
        return queryArray.join("&");
      };


export const appTitle = "Qlm Leltár";

export const appLocation = "Budapest";

export const socketUrl = "http://localhost:5000";

